import React from 'react';
import { ExamCard } from './ExamCard';

export const ExamGrid = ({ exams, onViewMockTests, onSelectPracticeMode }) => {
  if (exams.length === 0) {
    return (
        <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border">
            <h3 className="text-lg font-semibold text-brand-text-primary">No Exams Available</h3>
            <p className="text-brand-text-secondary mt-1">Please check back later.</p>
        </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {/* FIX: Removed erroneous key prop from being passed directly to ExamCard */}
      {exams.map((exam) => (
        <ExamCard 
            key={exam.id} 
            exam={exam} 
            onViewMockTests={onViewMockTests} 
            onSelectPracticeMode={onSelectPracticeMode} 
        />
      ))}
    </div>
  );
};
